module.exports = __webpack_public_path__ + "img/icon_top_discount_pre.8c2927ad.png";